export default __webpack_public_path__ + "static/media/GraphicDesign4.dac5c519.png";